module.exports = __webpack_public_path__ + "static/media/case-cockpit.2d4a6da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-cockpit.jpg
// module id = 79
// module chunks = 3